module.exports = __webpack_public_path__ + "static/media/top-rated-fund.763ac5ba.svg";